'use strict';
const	ComponentFactory	= require('factories/Component')
		, React 			= require('react')
		, loginstyle		= require('./_sidebar.style')
		, Rand34			= Math.floor(Math.random() * (2)) + 3
		, MainConfig		= require('main.config')
		;

module.exports = ComponentFactory.create({
	displayName : 'LoginPopupDesktopSidebar',
	render : function(){
		return (
			<div className={`col col-4 bg-c-disabled loginform-popup-h bs-bg-bridal bs-bg-bridal-fix`}>
				<div className="middle-transform">
					<div className="f-tac row row-no-gutter">
						<div className="row row-no-gutter">
							<div className="col col-10 wrapper">
								<h5 className="f-p-16 semibold">{ this.translator.toHTML('login.popup_label_vendor_note') }</h5>
								<p className="f-p-13 mt-10">{ this.translator.toHTML('login.popup_label_vendor_note_description') }</p>
								<a href={`${MainConfig.businessBaseUrl}${this.getLink('home')}`} className="btn btn-grey btn-block mt-20">{ this.translator.toHTML('login.login_link_sign_up_now') }</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
});



// WEBPACK FOOTER //
// resources/modules/components/login/popup/_sidebar.jsx